import i18n from '../../../../../../i18n';

export const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const SLUG_MIN = 3;
export const SLUG_MAX = 60;

export function validateSlugFormat(slug: string): string | null {
    if (!slug) return null;
    if (slug.length < SLUG_MIN || slug.length > SLUG_MAX) {
        return i18n.t('presEditPage.settings.shortLink.validationLength', {min: SLUG_MIN, max: SLUG_MAX});
    }
    if (!SLUG_REGEX.test(slug)) {
        return i18n.t('presEditPage.settings.shortLink.validationFormat');
    }
    return null;
}
